import React from "react";
import {
  About,
  Footer,
  Marquee,
  NavBar,
  Posters,
  Pricing,
  Splash,
  Stream,
} from "../components";

export const Home = () => (
  <>
    <NavBar />
    <Splash />
    <Marquee />
    <main>
      <About />
      <Pricing />
      <Posters />
      <Stream />
    </main>
    <Footer />
  </>
);
